import Card from "@/atoms/account/Card";
import { CardTitle, SecondaryTitle } from "../typography";
import Divider from "@/atoms/account/Divider";
import styled from "styled-components";
import StyledCurrency from "./StyledCurrency";

const Total = styled.div`
  font-size: 34px;
  font-weight: bold;
`;

const Referral = styled.div`
  font-size: 13px;
  font-weight: 500;
`;

const Referrals = ({ count, amount, referrals = [] }) => {
  return (
    <Card id={"referrals"}>
      <div className={"flex flex-wrap justify-between items-center"}>
        <CardTitle>Referrals</CardTitle>
      </div>
      <Divider className={"my-4"} />
      <div className={"grid grid-cols-2 gap-4"}>
        <div className={"bg-pulp-white rounded-lg p-4 text-center"}>
          <Total className={"text-textGray-darker"}>{count}</Total>
          <div className={"text-sm font-medium text-textGray-lighter"}>
            Referrals Claimed
          </div>
        </div>
        <div className={"bg-pulp-white rounded-lg p-4 text-center"}>
          <StyledCurrency
            className={"text-textGray-darker font-bold"}
            amount={amount}
          />
          <div className={"text-sm font-medium text-textGray-lighter"}>
            Referral Credit Earned
          </div>
        </div>
      </div>
      <div className={"grid gap-2 mt-4"}>
        <SecondaryTitle>Track Rewards</SecondaryTitle>
        {referrals.length === 0 && (
          <Referral
            className={"bg-pulp-white rounded-lg p-4 text-textGray-lighter"}
          >
            Refer friends today!
          </Referral>
        )}
        {referrals.map((referral) => (
          <Referral
            key={referral.id}
            className={
              "bg-pulp-white rounded-lg p-4 flex justify-between font-medium gap-4"
            }
          >
            <div>
              {referral.referree.firstName} {referral.referree.lastName}
            </div>
            <div className={"text-perriwinkle font-bold"}>
              {referral.creditAmount}
            </div>
          </Referral>
        ))}
      </div>
    </Card>
  );
};

export default Referrals;
